import React from 'react'
import HeaderConnector, { ConnectorProps as HeaderProps } from '../../connectors/Header'

import { HeaderContainer } from '../styles'

export default HeaderConnector(
  (props: HeaderProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const { description, title } = props
    return (
      <HeaderContainer>
        <h1 className='defaultTypographyH3'>{title}</h1>
        {description && (
          <div data-type='description-container'>
            <p className='defaultTypographySmall' data-type='header-description'>
              {description}
            </p>
          </div>
        )}
      </HeaderContainer>
    )
  }
)
